import styled from "styled-components";

const ClearfixContainer = styled.div`
  content: "";
  clear: both;
  width: 100%;
`;

export { ClearfixContainer };
